const T = require('prop-types');
const { default: Styled } = require('styled-components');
const { default: Tooltip } = require('@mui/material/Tooltip');
const { default: IconButton } = require('@mui/material/IconButton');
const { default: ChevronLeft } = require('@mui/icons-material/ChevronLeft');
const { default: ChevronRight } = require('@mui/icons-material/ChevronRight');
const { default: Classes } = require('./styles.scss');

const internals = {};

module.exports = NavigationButtonContainer;

function NavigationButtonContainer(props) {

    const {
        urlContext,
        discoveryResults,
        groupMembers,
        canNavigatePrev,
        canNavigateNext,
        canGroupNavigatePrev,
        canGroupNavigateNext,
        handleNavigatePrev,
        handleNavigateNext,
        children
    } = props;

    const { NavigationWrapper } = internals;

    const isFromDiscover = urlContext?.fromDiscover || false;
    const isFromGroup = urlContext?.fromGroup || false;

    const hasDiscoverResults = discoveryResults && discoveryResults.length > 0;
    const hasGroupResults = groupMembers && groupMembers.length > 0;

    const hasResults = isFromDiscover ? hasDiscoverResults : hasGroupResults;
    const canPrev = isFromDiscover ? canNavigatePrev : canGroupNavigatePrev;
    const canNext = isFromDiscover ? canNavigateNext : canGroupNavigateNext;

    const showNavigation = (isFromDiscover || isFromGroup) && hasResults;

    return (
        <NavigationWrapper>
            {showNavigation && <Tooltip
                arrow
                title='Previous profile'
                placement='left'
            >
                <IconButton
                    disabled={!canPrev}
                    onClick={handleNavigatePrev}
                    aria-label='previous profile'
                    size='medium'
                    data-focus-outline='radius:40'
                >
                    <ChevronLeft />
                </IconButton>
            </Tooltip>}
            <div className={Classes.button} style={{ flex: 1 }}>
                {children}
            </div>
            {showNavigation && <Tooltip
                arrow
                title='Next profile'
                placement='right'
            >
                <IconButton
                    disabled={!canNext}
                    onClick={handleNavigateNext}
                    aria-label='next profile'
                    size='medium'
                    data-focus-outline='radius:40'
                >
                    <ChevronRight />
                </IconButton>
            </Tooltip>}
        </NavigationWrapper>
    );
}

NavigationButtonContainer.propTypes = {
    urlContext: T.shape({
        fromDiscover: T.bool,
        fromGroup: T.bool,
        groupId: T.number,
        index: T.number
    }),
    discoveryResults: T.array,
    groupMembers: T.array,
    canNavigatePrev: T.bool,
    canNavigateNext: T.bool,
    canGroupNavigatePrev: T.bool,
    canGroupNavigateNext: T.bool,
    handleNavigatePrev: T.func,
    handleNavigateNext: T.func,
    children: T.node
};

internals.NavigationWrapper = Styled.div`
    display: flex;
    align-items: center;
    width: 100%;
    gap: 10px;
    padding: 10px 14px;

    .MuiIconButton-root {
        flex-shrink: 0;
        border: 1px solid rgba(0, 0, 0, 0.08);
        background: ${({ theme }) => theme.palette.background.paper};
        margin: 0;

        &:hover {
            background: ${({ theme }) => `${theme.palette.primary.main}14`};
            border-color: ${({ theme }) => `${theme.palette.primary.main}40`};
        }

        @media screen and (max-width: 600px) {
            padding: 8px;
        }
    }
`;
